import "./style.sass";
import assets from "../../assets";

export const DescriptiveHero = () => {
  return (
    <section className="descriptive-container">
      <section className="icon-circle">
        <img src={assets.ic_desc_test} alt="desc test" />
      </section>

      <h1 className="title">Descriptive Test</h1>
      <p className="subtitle">
        AI-powered question generation and intelligent evaluation system
      </p>

      <section className="info-card">
        <h3>Why use AI descriptive generator?</h3>

        <section className="feature">
          <section className="feature-icon">✔</section>
          <section>
            <h4>Contextual Relevance</h4>
            <p>
              Questions are generated based on specific curriculum nuances and
              Bloom’s Taxonomy.
            </p>
          </section>
        </section>

        <section className="feature">
          <section className="feature-icon">🔑</section>
          <section>
            <h4>Answer Key Inclusion</h4>
            <p>
              Every question comes with a detailed marking scheme and sample
              ideal response.
            </p>
          </section>
        </section>

        <section className="feature">
          <section className="feature-icon">⚡</section>
          <section>
            <h4>Instant Variation</h4>
            <p>
              Regenerate similar questions with different angles to ensure
              academic integrity.
            </p>
          </section>
        </section>
      </section>

      <section className="instruction-box">
        👉 Get started by selecting your subject, chapter, language,
        Number of Questions and Question Weightage
      </section>
    </section>
  );
};
